import { Flex, SegmentGroup } from "@chakra-ui/react-v3";

export type UnitSystem = "metric" | "imperial";

export type UnitSystemToggleProps = {
  unitSystem: UnitSystem;
  onChange: (unitSystem: UnitSystem) => void;
};

/**
 * Toggle component for switching between metric and imperial unit systems.
 * Used in the vitals table to convert temperature, weight, and height values.
 */
export function UnitSystemToggle({ unitSystem, onChange }: UnitSystemToggleProps) {
  return (
    <Flex alignItems="center">
      <SegmentGroup.Root
        value={unitSystem}
        onValueChange={({ value }: { value: UnitSystem }) => {
          onChange(value);
        }}
        size="sm"
        bg="bg.surface"
      >
        <SegmentGroup.Indicator />
        <SegmentGroup.Item value="metric" cursor="pointer">
          <SegmentGroup.ItemText fontWeight="medium">Metric</SegmentGroup.ItemText>
          <SegmentGroup.ItemHiddenInput />
        </SegmentGroup.Item>
        <SegmentGroup.Item value="imperial" cursor="pointer">
          <SegmentGroup.ItemText fontWeight="medium">Imperial</SegmentGroup.ItemText>
          <SegmentGroup.ItemHiddenInput />
        </SegmentGroup.Item>
      </SegmentGroup.Root>
    </Flex>
  );
}
